module.exports = "/_next/static/images/website-owners-4a1a18e8f578ee697f9c5a44edede9eb.svg";